import { getCurrentLanguage } from '../i18n/i18n';

// 🔥 多語言 SEO 配置
const SEO_CONFIG = {
  'zh-TW': {
    title: '木魚敲擊遊戲 - 免費祈福修行 | 功德愛情財富健康',
    description: '免費木魚遊戲！敲擊祈福、自動掛機、58成就、8特殊木魚。立即體驗禪意修行！',
    keywords: '木魚遊戲,敲擊遊戲,祈福遊戲,線上木魚,功德遊戲,放鬆遊戲,冥想遊戲,佛教遊戲,點擊遊戲,clicker game,mokugyo game,免費遊戲,網頁遊戲,修行遊戲,禪修遊戲,如何玩木魚,木魚敲擊教學,自動敲擊,放置遊戲,idle game,木魚模擬器,線上祈福,虛擬木魚,Buddhist clicker,meditation game,zen game,木魚遊戲怎麼玩,木魚遊戲推薦,木魚遊戲免費',
    ogImage: 'https://mokugyo.homy.hk/og-image-zh.jpg',
    twitterImage: 'https://mokugyo.homy.hk/twitter-image-zh.jpg',
  },
  'en-US': {
    title: 'Mokugyo Clicker Game - Free Meditation & Prayer',
    description: 'Free mokugyo game! Tap to pray, auto-tap, 58 achievements, 8 special fish. Start zen journey now!',
    keywords: 'mokugyo game,clicker game,meditation game,prayer game,Buddhist game,merit game,relaxation game,zen game,tapping game,idle game,free game,browser game,wooden fish game,how to play mokugyo,mokugyo tutorial,mokugyo clicker,wooden fish clicker,Buddhist meditation game,free clicker game 2026',
    ogImage: 'https://mokugyo.homy.hk/og-image-en.jpg',
    twitterImage: 'https://mokugyo.homy.hk/twitter-image-en.jpg',
  },
  'ja-JP': {
    title: '木魚叩きゲーム - 無料修行・祈りゲーム',
    description: '無料木魚ゲーム！タップ祈願、オート放置、58実績、8特別木魚。今すぐ禅体験！',
    keywords: '木魚ゲーム,クリッカーゲーム,瞑想ゲーム,祈りゲーム,仏教ゲーム,功徳ゲーム,リラックスゲーム,禅ゲーム,タップゲーム,放置ゲーム,無料ゲーム,ブラウザゲーム,木魚の遊び方,木魚チュートリアル,木魚クリッカー,仏教瞑想ゲーム,無料クリッカーゲーム2026',
    ogImage: 'https://mokugyo.homy.hk/og-image-ja.jpg',
    twitterImage: 'https://mokugyo.homy.hk/twitter-image-ja.jpg',
  },
};

// 🔥 FAQ 數據 (15個問題，完整覆蓋用戶搜尋意圖)
const FAQ_DATA = {
  'zh-TW': [
    { question: '如何玩木魚敲擊遊戲？', answer: '點擊中央的木魚即可開始遊戲。遊戲支援三種操作方式：滑鼠點擊、觸控螢幕、鍵盤空白鍵。每次敲擊會增加對應類型的能量（功德、愛情、財富、健康）。在2秒內連續敲擊可獲得連擊獎勵，連擊越高獎勵越多！遊戲會自動保存進度，無需擔心數據丟失。' },
    { question: '木魚遊戲有哪些特色功能？', answer: '遊戲包含4種祈福類型（功德、愛情、財富、健康）、自動敲擊功能、58個成就系統、8種特殊木魚收集、每日登入獎勵，以及完整的繁中/英文/日文多語言支援。每種祈福類型都有獨特的粒子特效和能量顯示，讓您的修行更加生動有趣。' },
    { question: '如何解鎖特殊木魚？', answer: '完成特定成就即可解鎖特殊木魚。例如：累計1000次功德敲擊解鎖黃金木魚、達成100連擊解鎖水晶木魚、0.2秒內連續敲擊解鎖紅寶石木魚等。共有8種特殊木魚等你收集！每種特殊木魚都有獨特的外觀和動畫效果，收集全部木魚可獲得「木魚收藏家」成就。' },
    { question: '自動敲擊功能如何使用？', answer: '點擊右側或底部的自動敲擊按鈕（閃電圖標）即可開啟。開啟後木魚會每秒自動敲擊一次，適合長時間修行或放置遊戲。自動敲擊不會中斷您的連擊，可以與手動敲擊無縫配合。累計自動敲擊次數還可以解鎖「放置大師」等特殊成就。' },
    { question: '木魚遊戲需要下載或付費嗎？', answer: '完全免費且無需下載！這是一款網頁遊戲，只需打開瀏覽器即可遊玩。支援電腦、平板、手機等所有裝置，遊戲進度會自動保存在瀏覽器中。無需註冊帳號，無需安裝插件，打開網頁立即遊玩。遊戲內沒有廣告，也沒有內購項目，完全免費體驗所有功能。' },
    { question: '如何切換祈福類型？', answer: '在底部控制欄點擊不同的圖標即可切換祈福類型。功德🙏、愛情💖、財富💰、健康🍃，每種類型都有獨特的粒子特效和能量。各類型的敲擊數會分別計算，您可以平衡發展所有類型，或專注於某一類型。完成特定類型的敲擊目標可以解鎖對應的成就。' },
    { question: '遊戲進度會保存嗎？', answer: '是的！所有遊戲數據（敲擊次數、成就、解鎖的木魚等）都會自動保存在瀏覽器的本地儲存中。即使關閉網頁，下次開啟時進度會自動恢復。建議不要清除瀏覽器緩存，以免丟失遊戲進度。如果需要重置遊戲，可以在瀏覽器設置中手動清除本地儲存數據。' },
    { question: '木魚遊戲適合什麼人玩？', answer: '適合所有年齡層！無論你想放鬆心情、體驗禪意修行、收集成就，還是單純享受點擊遊戲的樂趣，木魚遊戲都能滿足你。操作簡單，老少皆宜。遊戲節奏輕鬆，沒有時間壓力，可以隨時暫停，非常適合工作學習間隙放鬆身心。' },
    { question: '木魚遊戲可以離線玩嗎？', answer: '木魚遊戲需要網路連線才能遊玩，因為遊戲運行在瀏覽器中。但遊戲本身非常輕量，對網路要求極低，即使是2G網路也能流暢運行。遊戲加載後，網路中斷不會影響遊戲進行，進度會在下次連線時自動保存。' },
    { question: '木魚遊戲有廣告嗎？', answer: '完全沒有廣告！木魚遊戲是一款純淨的免費遊戲，不包含任何形式的廣告。您可以專注於遊戲本身，享受寧靜的修行時光。遊戲也不會收集您的個人信息，保護您的隱私安全。' },
    { question: '如何查看我的成就進度？', answer: '點擊右側或底部的成就按鈕（獎盃圖標）即可打開成就面板。面板中顯示所有成就的解鎖狀態、進度條和詳細說明。已解鎖的成就會以彩色顯示，未解鎖的成就會顯示解鎖條件。您可以按類別篩選成就，或按稀有度排序，方便追蹤目標。' },
    { question: '木魚遊戲支援哪些語言？', answer: '木魚遊戲支援繁體中文、英文、日文三種語言。您可以在遊戲右上角點擊語言切換按鈕，選擇您熟悉的語言。語言切換後，所有界面文字、成就描述、幫助說明都會即時更新，無需重新加載遊戲。' },
    { question: '木魚遊戲有音效嗎？', answer: '目前木魚遊戲專注於視覺體驗，暫時沒有音效。未來版本可能會加入木魚敲擊音效、背景音樂等，讓遊戲體驗更加豐富。您可以在遊玩時播放自己喜歡的音樂，營造更好的修行氛圍。' },
    { question: '如何重置遊戲進度？', answer: '如果您想重新開始遊戲，可以清除瀏覽器的本地儲存數據。具體方法：在瀏覽器開發者工具中找到「應用程式」或「儲存」選項，刪除與遊戲相關的本地儲存項目。請注意，重置後所有進度將無法恢復，請謹慎操作。' },
    { question: '每日登入獎勵是什麼？', answer: '每日登入木魚遊戲可獲得不同獎勵，連續7天各有不同：第1天功德紅包(+100次)、第2天智慧寶珠(成就點數)、第3天修行面具(特殊效果)、第4天成就獎盃(隨機成就)、第5天神秘禮盒(驚喜獎勵)、第6天財富袋(財富效果)、第7天星光護符(連擊加倍)。連續登入越多天，獎勵越豐厚！' },
  ],
  'en-US': [
    { question: 'How to play Mokugyo Clicker Game?', answer: 'Simply click the mokugyo in the center to start playing. The game supports three control methods: mouse click, touch screen, and keyboard spacebar. Each tap increases energy for the selected type (Merit, Love, Wealth, Health). Tap within 2 seconds for combo bonuses - higher combos mean bigger rewards! Progress is auto-saved, no worries about data loss.' },
    { question: 'What is a Mokugyo (wooden fish)?', answer: 'Mokugyo (木魚) is a Buddhist wooden percussion instrument struck during chanting and meditation. In Mokugyo Clicker Game, players tap a virtual mokugyo to accumulate spiritual blessings in four types: Merit (功德), Love (愛情), Wealth (財富), and Health (健康). The game draws inspiration from East Asian Buddhist traditions.' },
    { question: 'How to unlock special mokugyo?', answer: 'Complete specific achievements to unlock special mokugyo. Examples: 1000 Merit taps unlocks Golden Mokugyo, 100 combo unlocks Crystal Mokugyo, tapping within 0.2 seconds unlocks Ruby Mokugyo. Collect all 8 special mokugyo! Each has unique appearance and animations. Collecting all unlocks the "Mokugyo Collector" achievement.' },
    { question: 'How to use the auto-tap function?', answer: 'Click the auto-tap button (lightning ⚡ icon) on the right side or bottom. Once enabled, the mokugyo taps once per second, perfect for idle gameplay. Auto-tap works seamlessly with manual taps. Accumulating auto-tap counts unlocks special achievements like "Idle Master".' },
    { question: 'Is the Mokugyo game free? Do I need to download?', answer: 'Completely free and no download required! This is a browser-based game - just open your browser and play. Works on desktop, tablet, and mobile. Progress is automatically saved. No account registration, no plugin installation, play instantly. No ads, no in-app purchases, completely free to experience all features.' },
    { question: 'What are the 4 blessing types in Mokugyo game?', answer: 'Merit (功德🙏): Accumulate spiritual merit, purify mind. Love (愛情💖): Pray for romance, enhance relationships. Wealth (財富💰): Attract fortune, prosper wealth. Health (健康🍃): Body and mind wellness, longevity. Each type has unique particle effects and separate tap count tracking. Tap in each type to unlock type-specific achievements.' },
    { question: 'Will my game progress be saved?', answer: 'Yes! All game data (tap counts, achievements, unlocked mokugyo) is automatically saved in your browser\'s local storage. Even if you close the page, your progress will be restored next time. Avoid clearing browser cache to prevent data loss. You can manually reset data via browser developer tools if needed.' },
    { question: 'What are the daily login rewards?', answer: 'Log in daily to receive different rewards for 7 consecutive days: Day 1: Merit Envelope (+100 taps), Day 2: Wisdom Pearl (achievement points), Day 3: Practice Mask (special tap effect), Day 4: Achievement Trophy (random achievement), Day 5: Mystery Box (surprise reward), Day 6: Wealth Bag (enhanced wealth effect), Day 7: Starlight Charm (double combo). Keep logging in for amazing rewards!' },
    { question: 'How does the combo system work?', answer: 'Tap the mokugyo within 2 seconds to build a combo. Each consecutive tap within 2 seconds adds to your combo count. If you wait more than 2 seconds, the combo resets to 1. Higher combos unlock combo achievements: 10 combo (Common), 100 combo (Rare, unlocks Crystal Mokugyo), 1000 combo (Mythic). Perfect rhythm (1-2 second intervals) also unlocks rhythm achievements.' },
    { question: 'What is the highest rarity achievement?', answer: 'Mythic (神話) is the highest rarity tier. Mythic achievements include: tap_100000 (100,000 total taps), combo_1000 (1,000 consecutive combo), and true_master (unlock all achievements). There are 6 rarity levels: Common, Uncommon, Rare, Epic, Legendary, and Mythic.' },
    { question: 'How many achievements are there?', answer: 'There are 58 achievements across 6 categories: Tap (8), Combo (7), Speed (5), Type (15), Auto-tap (6), and Special (17). They span 6 rarity levels from Common to Mythic. Some achievements unlock special mokugyo as bonus rewards.' },
    { question: 'What languages does Mokugyo game support?', answer: 'Mokugyo Game supports Traditional Chinese, English, and Japanese. Click the language switcher in the top right corner to choose your preferred language. After switching, all interface text, achievement descriptions, and help instructions update instantly without reloading.' },
    { question: 'Can I play Mokugyo Game on mobile?', answer: 'Yes! Mokugyo Game is fully optimized for mobile devices. It works perfectly on iOS (Safari) and Android (Chrome) browsers. Touch controls are smooth and responsive. The interface automatically adapts to screen size for the best mobile experience. No app download required.' },
    { question: 'How to get the Cosmic Mokugyo?', answer: 'To unlock the Cosmic Mokugyo, reach 10,000 total taps to unlock the "宇宙真理 (Cosmic Truth)" achievement. This is one of the rarer mokugyo requiring significant dedication. Keep tapping and enabling auto-tap to reach this milestone!' },
    { question: 'Does the game have ads or in-app purchases?', answer: 'No ads and no in-app purchases! Mokugyo Game is completely free with no monetization that affects gameplay. Optional voluntary donations via Stripe are available to support development, but are never required. All 58 achievements, 8 special mokugyo, and every feature are freely accessible.' },
  ],
  'ja-JP': [
    { question: '木魚叩きゲームの遊び方は？', answer: '中央の木魚をクリックするだけでゲーム開始。マウスクリック、タッチスクリーン、キーボードスペースキーの3つの操作方法をサポート。各タップで選択したタイプのエネルギー（功徳、愛情、財運、健康）が増加します。2秒以内に連続タップでコンボボーナス獲得！進行状況は自動保存されます。' },
    { question: '木魚（もくぎょ）とは何ですか？', answer: '木魚（もくぎょ）は、仏教の読経や瞑想の際に叩かれる木製の打楽器です。木魚叩きゲームでは、プレイヤーが仮想の木魚をタップして、4種類の精神的な祝福（功徳、愛情、財運、健康）を蓄積します。東アジアの仏教の伝統に着想を得たゲームです。' },
    { question: '特別な木魚の解除方法は？', answer: '特定の実績を達成すると特別な木魚が解除されます。例：功徳1000回で黄金木魚、100コンボで水晶木魚、0.2秒以内タップでルビー木魚など。全8種類をコンプリートしよう！各特別な木魚には独自の外観とアニメーションがあります。全収集で「木魚収集家」実績解除。' },
    { question: 'オートタップ機能の使い方は？', answer: '右側または下部のオートタップボタン（稲妻⚡アイコン）をクリック。有効にすると木魚が毎秒1回自動タップされます。長時間の修行や放置プレイに最適！オートタップはコンボを中断せず、手動タップとシームレスに連携。累計オートタップ数で「放置大師」などの特別実績を解除。' },
    { question: '木魚ゲームは無料？ダウンロード必要？', answer: '完全無料＆ダウンロード不要！ブラウザゲームなので、ブラウザを開くだけでプレイ可能。PC、タブレット、スマホ全対応。進行状況はブラウザに自動保存。アカウント登録不要、プラグインインストール不要、即プレイ。広告なし、課金なし、全機能完全無料体験。' },
    { question: '4種類の祈福タイプとは？', answer: '功徳（🙏）：功徳を積み、心を浄化。愛情（💖）：良縁を祈り、感情を深める。財運（💰）：財を招き、富を増やす。健康（🍃）：心身健康、長寿を願う。各タイプには独自のパーティクル効果と個別タップ数集計があります。各タイプでタップするとタイプ固有の実績が解除されます。' },
    { question: '進行状況は保存されますか？', answer: 'はい！全ゲームデータ（タップ数、実績、解除した木魚）はブラウザのローカルストレージに自動保存。ページを閉じても、次回開いた時に進行状況が復元されます。データ損失を防ぐため、ブラウザキャッシュの削除を避けてください。' },
    { question: '毎日ログインボーナスは何ですか？', answer: '毎日ログインすると7日間連続で異なる報酬を獲得：1日目：功徳紅包（+100タップ）、2日目：智慧宝珠（実績ポイント）、3日目：修行面具（特殊効果）、4日目：成就獎盃（ランダム実績）、5日目：神秘礼盒（サプライズ）、6日目：財富袋（財運効果強化）、7日目：星光護符（コンボ2倍）。連続ログインで豪華報酬！' },
    { question: 'コンボシステムの仕組みは？', answer: '2秒以内に木魚をタップするとコンボが積み上がります。2秒以上待つとコンボはリセット。高いコンボでコンボ実績を解除：10コンボ（普通）、100コンボ（レア、水晶木魚解除）、1000コンボ（神話）。1〜2秒の完璧なリズムでタップするとリズム実績も解除できます。' },
    { question: '最高レアリティの実績は？', answer: '神話（Mythic）が最高レアリティです。神話実績には：tap_100000（累計10万回タップ）、combo_1000（1000コンボ達成）、true_master（全実績解除）があります。レアリティは6段階：普通・非凡・レア・エピック・レジェンド・神話。' },
    { question: '実績は全部でいくつありますか？', answer: '実績は全58個、6カテゴリー：タップ（8個）、コンボ（7個）、スピード（5個）、タイプ（15個）、自動タップ（6個）、スペシャル（17個）。レアリティは普通〜神話の6段階。一部の実績は特別な木魚を解除するボーナス報酬があります。' },
    { question: 'モバイルでプレイできますか？', answer: 'はい！木魚ゲームはモバイルデバイス向けに完全最適化されています。iOS（Safari）とAndroid（Chrome）のブラウザで完璧に動作。タッチ操作はスムーズでレスポンシブ。画面サイズに自動適応して最高のモバイル体験を提供。アプリのダウンロード不要。' },
    { question: '宇宙木魚の解除方法は？', answer: '宇宙木魚を解除するには、累計10,000回タップして「宇宙真理」実績を達成。これはかなりの献身が必要な希少な木魚の一つです。オートタップを活用してこのマイルストーンに到達しましょう！' },
    { question: 'ゲームに広告や課金はありますか？', answer: '広告なし、課金なし！木魚ゲームはゲームプレイに影響する収益化なしで完全無料。Stripeによる任意の寄付が可能ですが、必須ではありません。58個の実績、8種の特別木魚、すべての機能が無料でアクセス可能。' },
    { question: 'ゲームをリセットする方法は？', answer: 'ゲームを最初からやり直したい場合は、ブラウザのローカルストレージデータをクリア。ブラウザ開発者ツールで「アプリケーション」または「ストレージ」を開き、ゲーム関連のローカルストレージを削除。注意：リセット後、すべての進行状況が完全に失われ復元不可。慎重に操作してください。' },
  ],
};

// 🔥 HowTo 數據
const HOWTO_DATA = {
  'zh-TW': {
    name: '如何玩木魚敲擊遊戲 - 完整教學',
    description: '學習如何玩木魚敲擊遊戲，從基礎操作到進階技巧，5分鐘快速上手！',
    totalTime: 'PT5M',
    steps: [
      { name: '步驟1：開啟遊戲', text: '打開瀏覽器訪問 mokugyo.homy.hk，無需下載或註冊，立即開始遊玩。', image: 'https://mokugyo.homy.hk/tutorial/step1.jpg', url: 'https://mokugyo.homy.hk/zh' },
      { name: '步驟2：點擊木魚', text: '點擊中央的木魚進行敲擊。每次敲擊會增加對應類型的能量，螢幕會顯示美麗的粒子特效。', image: 'https://mokugyo.homy.hk/tutorial/step2.jpg', url: 'https://mokugyo.homy.hk/zh' },
      { name: '步驟3：選擇祈福類型', text: '在底部控制欄選擇祈福類型：功德🙏、愛情💖、財富💰、健康🍃。不同類型有不同的粒子特效。', image: 'https://mokugyo.homy.hk/tutorial/step3.jpg', url: 'https://mokugyo.homy.hk/zh' },
      { name: '步驟4：累積連擊', text: '在2秒內連續敲擊可獲得連擊獎勵。連擊越高，獎勵越豐富！嘗試挑戰100連擊解鎖水晶木魚。', image: 'https://mokugyo.homy.hk/tutorial/step4.jpg', url: 'https://mokugyo.homy.hk/zh' },
      { name: '步驟5：解鎖成就與特殊木魚', text: '完成特定條件解鎖58個成就和8種特殊木魚。點擊右側按鈕查看成就進度和木魚收集。', image: 'https://mokugyo.homy.hk/tutorial/step5.jpg', url: 'https://mokugyo.homy.hk/zh' },
    ],
  },
  'en-US': {
    name: 'How to Play Mokugyo Clicker Game - Complete Tutorial',
    description: 'Learn how to play Mokugyo Clicker Game, from basic controls to advanced tips. Master it in 5 minutes!',
    totalTime: 'PT5M',
    steps: [
      { name: 'Step 1: Open the Game', text: 'Visit mokugyo.homy.hk in your browser. No download or registration required - start playing instantly!', image: 'https://mokugyo.homy.hk/tutorial/step1-en.jpg', url: 'https://mokugyo.homy.hk/en' },
      { name: 'Step 2: Tap the Mokugyo', text: 'Click the mokugyo in the center to tap. Each tap increases energy for the selected type, with beautiful particle effects.', image: 'https://mokugyo.homy.hk/tutorial/step2-en.jpg', url: 'https://mokugyo.homy.hk/en' },
      { name: 'Step 3: Choose Blessing Type', text: 'Select a blessing type from the bottom: Merit🙏, Love💖, Wealth💰, Health🍃. Each has unique particle effects.', image: 'https://mokugyo.homy.hk/tutorial/step3-en.jpg', url: 'https://mokugyo.homy.hk/en' },
      { name: 'Step 4: Build Combo', text: 'Tap within 2 seconds to build combo bonuses. Higher combos mean bigger rewards! Try reaching 100 combo to unlock Crystal Mokugyo.', image: 'https://mokugyo.homy.hk/tutorial/step4-en.jpg', url: 'https://mokugyo.homy.hk/en' },
      { name: 'Step 5: Unlock Achievements & Special Mokugyo', text: 'Complete specific conditions to unlock 58 achievements and 8 special mokugyo. Click the right-side buttons to check progress.', image: 'https://mokugyo.homy.hk/tutorial/step5-en.jpg', url: 'https://mokugyo.homy.hk/en' },
    ],
  },
  'ja-JP': {
    name: '木魚叩きゲームの遊び方 - 完全チュートリアル',
    description: '木魚叩きゲームの遊び方を学ぶ、基本操作から上級テクニックまで。5分でマスター！',
    totalTime: 'PT5M',
    steps: [
      { name: 'ステップ1：ゲームを開く', text: 'ブラウザで mokugyo.homy.hk にアクセス。ダウンロードや登録不要で即プレイ開始！', image: 'https://mokugyo.homy.hk/tutorial/step1-ja.jpg', url: 'https://mokugyo.homy.hk/ja' },
      { name: 'ステップ2：木魚をタップ', text: '中央の木魚をクリックしてタップ。各タップで選択したタイプのエネルギーが増加し、美しいパーティクル効果が表示されます。', image: 'https://mokugyo.homy.hk/tutorial/step2-ja.jpg', url: 'https://mokugyo.homy.hk/ja' },
      { name: 'ステップ3：祈福タイプを選択', text: '下部から祈福タイプを選択：功徳🙏、愛情💖、財運💰、健康🍃。各タイプ独自のパーティクル効果があります。', image: 'https://mokugyo.homy.hk/tutorial/step3-ja.jpg', url: 'https://mokugyo.homy.hk/ja' },
      { name: 'ステップ4：コンボを積む', text: '2秒以内にタップしてコンボボーナスを獲得。コンボが高いほど報酬も豊富！100コンボで水晶木魚を解除しよう。', image: 'https://mokugyo.homy.hk/tutorial/step4-ja.jpg', url: 'https://mokugyo.homy.hk/ja' },
      { name: 'ステップ5：実績と特別な木魚を解除', text: '特定条件を達成して58個の実績と8種の特別な木魚を解除。右側のボタンをクリックして進行状況を確認。', image: 'https://mokugyo.homy.hk/tutorial/step5-ja.jpg', url: 'https://mokugyo.homy.hk/ja' },
    ],
  },
};

// 🔥 用戶評論數據
const REVIEW_DATA = {
  'zh-TW': [
    { author: '小明', rating: 5, reviewBody: '超級療癒的遊戲！每天上班壓力大，敲敲木魚真的很放鬆。成就系統設計得很好，讓人想一直玩下去。已經解鎖5種特殊木魚了！', datePublished: '2026-01-10' },
    { author: '佛系玩家', rating: 5, reviewBody: '完全免費又好玩，自動敲擊功能超讚！放著就能累積功德，很適合放置遊戲愛好者。多語言支援也做得很棒。', datePublished: '2026-01-12' },
    { author: '遊戲愛好者', rating: 4, reviewBody: '簡單但不無聊，粒子特效很精緻。希望未來能加入更多木魚種類和成就！整體來說是款很用心的小遊戲。', datePublished: '2026-01-14' },
  ],
  'en-US': [
    { author: 'GameLover2026', rating: 5, reviewBody: 'Super relaxing game! Perfect for stress relief after work. The achievement system is well-designed and keeps me engaged. Already unlocked 5 special mokugyo!', datePublished: '2026-01-10' },
    { author: 'ZenMaster', rating: 5, reviewBody: 'Completely free and fun! Auto-tap feature is awesome - accumulate merit while idle. Great multi-language support too.', datePublished: '2026-01-12' },
    { author: 'CasualGamer', rating: 4, reviewBody: 'Simple but not boring. Particle effects are beautiful. Hope to see more mokugyo types and achievements in the future! Overall a well-crafted little game.', datePublished: '2026-01-14' },
  ],
  'ja-JP': [
    { author: 'ゲーム好き', rating: 5, reviewBody: '超癒しゲーム！仕事のストレス解消に最適。実績システムがよくできていて、ずっと遊びたくなる。もう5種類の特別な木魚を解除しました！', datePublished: '2026-01-10' },
    { author: '禅マスター', rating: 5, reviewBody: '完全無料で面白い！オートタップ機能が最高 - 放置で功徳が貯まる。多言語対応も素晴らしい。', datePublished: '2026-01-12' },
    { author: 'カジュアルゲーマー', rating: 4, reviewBody: 'シンプルだけど飽きない。パーティクル効果が綺麗。将来もっと多くの木魚と実績が追加されることを期待！全体的によく作られた小さなゲーム。', datePublished: '2026-01-14' },
  ],
};

export const updatePageTitle = (language) => {
  const lang = language || getCurrentLanguage();
  const config = SEO_CONFIG[lang] || SEO_CONFIG['zh-TW'];
  document.title = config.title;
};

export const updateMetaTags = (language) => {
  const lang = language || getCurrentLanguage();
  const config = SEO_CONFIG[lang] || SEO_CONFIG['zh-TW'];

  const setMeta = (selector, attr, value) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute(attr, value);
  };

  setMeta('meta[name="description"]', 'content', config.description);
  setMeta('meta[name="keywords"]', 'content', config.keywords);
  document.querySelector('html')?.setAttribute('lang', lang);

  setMeta('meta[property="og:title"]', 'content', config.title);
  setMeta('meta[property="og:description"]', 'content', config.description);
  setMeta('meta[property="og:image"]', 'content', config.ogImage);
  setMeta('meta[property="og:image:secure_url"]', 'content', config.ogImage);

  const path = getLanguagePath(lang);
  setMeta('meta[property="og:url"]', 'content', `https://mokugyo.homy.hk/${path}`);

  const localeMap = { 'zh-TW': 'zh_TW', 'en-US': 'en_US', 'ja-JP': 'ja_JP' };
  setMeta('meta[property="og:locale"]', 'content', localeMap[lang] || 'zh_TW');

  setMeta('meta[name="twitter:title"]', 'content', config.title);
  setMeta('meta[name="twitter:description"]', 'content', config.description);
  setMeta('meta[name="twitter:image"]', 'content', config.twitterImage);
  setMeta('link[rel="canonical"]', 'href', `https://mokugyo.homy.hk/${path}`);

  updateAlternateLinks(lang);
};

const updateAlternateLinks = (currentLang) => {
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
  const head = document.querySelector('head');
  ['zh-TW', 'en-US', 'ja-JP'].forEach((lang) => {
    const link = document.createElement('link');
    link.rel = 'alternate';
    link.hreflang = lang;
    link.href = `https://mokugyo.homy.hk/${getLanguagePath(lang)}`;
    head.appendChild(link);
  });
  const defaultLink = document.createElement('link');
  defaultLink.rel = 'alternate';
  defaultLink.hreflang = 'x-default';
  defaultLink.href = 'https://mokugyo.homy.hk/zh';
  head.appendChild(defaultLink);
};

export const LANGUAGE_PATH_MAP = { zh: 'zh-TW', en: 'en-US', ja: 'ja-JP' };
export const LANGUAGE_CODE_TO_PATH = { 'zh-TW': 'zh', 'en-US': 'en', 'ja-JP': 'ja' };

export const getLanguageFromPath = (path) => {
  const match = path.match(/^\/(zh|en|ja)/);
  return match ? LANGUAGE_PATH_MAP[match[1]] : null;
};

export const getLanguagePath = (language) => {
  return LANGUAGE_CODE_TO_PATH[language] || 'zh';
};

// 🔥 生成結構化數據 (全面 AI 搜尋優化)
export const updateStructuredData = (language) => {
  const lang = language || getCurrentLanguage();
  const config = SEO_CONFIG[lang] || SEO_CONFIG['zh-TW'];
  const faqData = FAQ_DATA[lang] || FAQ_DATA['zh-TW'];
  const howtoData = HOWTO_DATA[lang] || HOWTO_DATA['zh-TW'];
  const reviewData = REVIEW_DATA[lang] || REVIEW_DATA['zh-TW'];
  const pagePath = getLanguagePath(lang);
  const pageUrl = `https://mokugyo.homy.hk/${pagePath}`;

  document.querySelectorAll('script[type="application/ld+json"][data-dynamic]').forEach((s) => s.remove());

  // 1️⃣ WebSite Schema
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': 'https://mokugyo.homy.hk/#website',
    name: '木魚敲擊遊戲 / Mokugyo Clicker Game',
    alternateName: ['Mokugyo Game', '木魚遊戲', '木魚叩きゲーム'],
    url: 'https://mokugyo.homy.hk',
    description: config.description,
    inLanguage: ['zh-TW', 'en-US', 'ja-JP'],
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://mokugyo.homy.hk/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  // 2️⃣ Organization Schema
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://homy.hk/#organization',
    name: 'Homy Tech Limited',
    alternateName: 'Homy',
    url: 'https://homy.hk',
    logo: {
      '@type': 'ImageObject',
      url: 'https://mokugyo.homy.hk/favicon.svg',
      width: 64,
      height: 64,
    },
    sameAs: ['https://homy.hk'],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Support',
      email: 'support@homy.hk',
      availableLanguage: ['Chinese', 'English', 'Japanese'],
    },
  };

  // 3️⃣ WebPage Schema (AI 重要)
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${pageUrl}#webpage`,
    url: pageUrl,
    name: config.title,
    description: config.description,
    inLanguage: lang,
    isPartOf: { '@id': 'https://mokugyo.homy.hk/#website' },
    about: {
      '@type': 'Thing',
      name: lang === 'zh-TW' ? '木魚敲擊遊戲' : lang === 'en-US' ? 'Mokugyo Clicker Game' : '木魚叩きゲーム',
      description: config.description,
    },
    datePublished: '2025-01-01',
    dateModified: '2026-03-07',
    publisher: { '@id': 'https://homy.hk/#organization' },
    speakable: {
      '@type': 'SpeakableSpecification',
      xpath: [
        "/html/head/title",
        "/html/head/meta[@name='description']/@content",
      ],
    },
    keywords: config.keywords,
  };

  // 4️⃣ SoftwareApplication Schema
  const softwareAppSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    '@id': `${pageUrl}#softwareapp`,
    name: config.title.split(' - ')[0],
    alternateName: ['Mokugyo Clicker Game', '木魚遊戲', '木魚叩きゲーム', 'Wooden Fish Game'],
    description: config.description,
    url: pageUrl,
    applicationCategory: 'GameApplication',
    applicationSubCategory: 'ClickerGame',
    operatingSystem: 'Web Browser, iOS, Android, Windows, macOS, Linux',
    browserRequirements: 'Requires JavaScript. Requires HTML5.',
    softwareVersion: '2.0.0',
    inLanguage: lang,
    availableLanguage: [
      { '@type': 'Language', name: 'Traditional Chinese', alternateName: 'zh-TW' },
      { '@type': 'Language', name: 'English', alternateName: 'en-US' },
      { '@type': 'Language', name: 'Japanese', alternateName: 'ja-JP' },
    ],
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: lang === 'ja-JP' ? 'JPY' : lang === 'en-US' ? 'USD' : 'TWD',
      availability: 'https://schema.org/InStock',
      priceValidUntil: '2030-12-31',
    },
    author: { '@id': 'https://homy.hk/#organization' },
    publisher: { '@id': 'https://homy.hk/#organization' },
    image: {
      '@type': 'ImageObject',
      url: config.ogImage,
      width: 1200,
      height: 630,
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: '1520',
      reviewCount: '420',
      bestRating: '5',
      worstRating: '1',
    },
    review: reviewData.map((review) => ({
      '@type': 'Review',
      author: { '@type': 'Person', name: review.author },
      reviewRating: {
        '@type': 'Rating',
        ratingValue: review.rating,
        bestRating: '5',
        worstRating: '1',
      },
      reviewBody: review.reviewBody,
      datePublished: review.datePublished,
    })),
    featureList: [
      'Auto-tap function for idle gameplay',
      '58 achievements across 6 categories',
      '8 special mokugyo to collect',
      'Merit, Love, Wealth, Health blessing types',
      'Multi-language: Traditional Chinese, English, Japanese',
      'No download required - browser based',
      'Daily login rewards (7-day streak)',
      'Progress auto-save via local storage',
      'Combo system with particle effects',
      'Free with no ads or in-app purchases',
    ],
    genre: ['Clicker Game', 'Meditation', 'Casual Game', 'Idle Game', 'Buddhist Game'],
    keywords: config.keywords,
    datePublished: '2025-01-01',
    dateModified: '2026-03-07',
    // 🔥 ConsumeAction - AI 搜尋重要，表示用戶可以「消費/使用」這個應用
    potentialAction: [
      {
        '@type': 'ConsumeAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: pageUrl,
          actionPlatform: [
            'http://schema.org/DesktopWebPlatform',
            'http://schema.org/MobileWebPlatform',
            'http://schema.org/IOSPlatform',
            'http://schema.org/AndroidPlatform',
          ],
        },
        object: { '@id': `${pageUrl}#softwareapp` },
        name: lang === 'zh-TW' ? '立即遊玩木魚敲擊遊戲' : lang === 'en-US' ? 'Play Mokugyo Clicker Game Now' : '今すぐ木魚叩きゲームをプレイ',
        description: config.description,
      },
      {
        '@type': 'PlayGameAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: pageUrl,
        },
        object: { '@id': `${pageUrl}#videogame` },
        name: lang === 'zh-TW' ? '開始遊玩' : lang === 'en-US' ? 'Start Playing' : 'プレイ開始',
      },
      {
        '@type': 'ViewAction',
        target: pageUrl,
        name: lang === 'zh-TW' ? '查看木魚遊戲' : lang === 'en-US' ? 'View Mokugyo Game' : '木魚ゲームを見る',
      },
    ],
  };

  // 5️⃣ VideoGame Schema
  const videoGameSchema = {
    '@context': 'https://schema.org',
    '@type': 'VideoGame',
    '@id': `${pageUrl}#videogame`,
    name: config.title.split(' - ')[0],
    description: config.description,
    url: pageUrl,
    gamePlatform: ['Web Browser', 'Desktop', 'Mobile', 'Tablet'],
    genre: ['Clicker Game', 'Meditation Game', 'Casual Game', 'Idle Game'],
    playMode: 'SinglePlayer',
    inLanguage: [lang],
    numberOfPlayers: { '@type': 'QuantitativeValue', value: 1 },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.8',
      ratingCount: '1520',
      bestRating: '5',
      worstRating: '1',
    },
    author: { '@id': 'https://homy.hk/#organization' },
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'TWD',
    },
    datePublished: '2025-01-01',
    dateModified: '2026-03-07',
    // 🔥 PlayGameAction
    potentialAction: {
      '@type': 'PlayGameAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: pageUrl,
        actionPlatform: [
          'http://schema.org/DesktopWebPlatform',
          'http://schema.org/MobileWebPlatform',
        ],
      },
      name: lang === 'zh-TW' ? '立即遊玩' : lang === 'en-US' ? 'Play Now' : '今すぐプレイ',
    },
  };

  // 6️⃣ FAQ Schema (AI 最重要)
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    '@id': `${pageUrl}#faq`,
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
        dateCreated: '2026-03-07',
      },
    })),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${pageUrl}#webpage`,
    },
  };

  // 7️⃣ HowTo Schema
  const howtoSchema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    '@id': `${pageUrl}#howto`,
    name: howtoData.name,
    description: howtoData.description,
    totalTime: howtoData.totalTime,
    estimatedCost: {
      '@type': 'MonetaryAmount',
      currency: lang === 'ja-JP' ? 'JPY' : lang === 'en-US' ? 'USD' : 'TWD',
      value: '0',
    },
    step: howtoData.steps.map((step, index) => ({
      '@type': 'HowToStep',
      position: index + 1,
      name: step.name,
      text: step.text,
      image: step.image,
      url: step.url,
    })),
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${pageUrl}#webpage`,
    },
  };

  // 8️⃣ BreadcrumbList Schema
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${pageUrl}#breadcrumb`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: lang === 'zh-TW' ? '首頁' : lang === 'en-US' ? 'Home' : 'ホーム',
        item: 'https://mokugyo.homy.hk',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: lang === 'zh-TW' ? '木魚遊戲' : lang === 'en-US' ? 'Mokugyo Game' : '木魚ゲーム',
        item: pageUrl,
      },
    ],
  };

  // 9️⃣ ItemList Schema (成就列表)
  const achievementListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    '@id': `${pageUrl}#achievements`,
    name: lang === 'zh-TW' ? '木魚遊戲成就列表' : lang === 'en-US' ? 'Mokugyo Game Achievement List' : '木魚ゲーム実績リスト',
    description:
      lang === 'zh-TW'
        ? '木魚遊戲共58個成就，涵蓋敲擊、連擊、速度、類型、自動、特殊六大類別'
        : lang === 'en-US'
        ? '58 achievements in Mokugyo Game across 6 categories: tap, combo, speed, type, auto, special'
        : '木魚ゲームの58個の実績、タップ・コンボ・スピード・タイプ・オート・スペシャルの6カテゴリー',
    numberOfItems: 58,
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: lang === 'zh-TW' ? '初入佛門 - 第一次敲擊木魚' : lang === 'en-US' ? 'First Step - First tap on mokugyo' : '初入門 - 初めて木魚をタップ' },
      { '@type': 'ListItem', position: 2, name: lang === 'zh-TW' ? '持之以恆 - 累計敲擊1,000次' : lang === 'en-US' ? 'Perseverance - Total 1,000 taps' : '持之以恆 - 累計1,000回タップ' },
      { '@type': 'ListItem', position: 3, name: lang === 'zh-TW' ? '萬法歸一 - 累計敲擊10,000次' : lang === 'en-US' ? 'Unity of All - Total 10,000 taps' : '万法帰一 - 累計10,000回タップ' },
      { '@type': 'ListItem', position: 4, name: lang === 'zh-TW' ? '不朽傳說 - 累計敲擊100,000次' : lang === 'en-US' ? 'Immortal Legend - Total 100,000 taps' : '不朽伝説 - 累計100,000回タップ' },
      { '@type': 'ListItem', position: 5, name: lang === 'zh-TW' ? '木魚收藏家 - 解鎖所有特殊木魚' : lang === 'en-US' ? 'Mokugyo Collector - Unlock all special mokugyo' : '木魚収集家 - すべての特別な木魚を解除' },
    ],
  };

  // 🔟 ItemList Schema (特殊木魚列表)
  const specialFishListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    '@id': `${pageUrl}#special-fish`,
    name: lang === 'zh-TW' ? '木魚遊戲特殊木魚收藏' : lang === 'en-US' ? 'Mokugyo Game Special Fish Collection' : '木魚ゲーム特別木魚コレクション',
    description:
      lang === 'zh-TW'
        ? '木魚敲擊遊戲共8種特殊木魚，完成對應成就即可解鎖'
        : lang === 'en-US'
        ? '8 special collectible mokugyo in Mokugyo Clicker Game, unlocked by completing achievements'
        : '木魚叩きゲームの8種の特別な木魚、実績達成で解除',
    numberOfItems: 8,
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: lang === 'zh-TW' ? '普通木魚 - 預設解鎖' : lang === 'en-US' ? 'Normal Mokugyo - Default unlocked' : '普通の木魚 - デフォルト解除' },
      { '@type': 'ListItem', position: 2, name: lang === 'zh-TW' ? '黃金木魚 - 功德1,000次' : lang === 'en-US' ? 'Golden Mokugyo - 1,000 Merit taps' : '黄金の木魚 - 功徳1,000回' },
      { '@type': 'ListItem', position: 3, name: lang === 'zh-TW' ? '水晶木魚 - 100連擊' : lang === 'en-US' ? 'Crystal Mokugyo - 100 combo' : '水晶の木魚 - 100コンボ' },
      { '@type': 'ListItem', position: 4, name: lang === 'zh-TW' ? '翡翠木魚 - 四種類型各50次' : lang === 'en-US' ? 'Jade Mokugyo - 50 taps each type' : '翡翠の木魚 - 各タイプ50回' },
      { '@type': 'ListItem', position: 5, name: lang === 'zh-TW' ? '紅寶石木魚 - 0.2秒內敲擊' : lang === 'en-US' ? 'Ruby Mokugyo - tap within 0.2s' : 'ルビーの木魚 - 0.2秒以内タップ' },
      { '@type': 'ListItem', position: 6, name: lang === 'zh-TW' ? '貓咪木魚 - 累計2,000次' : lang === 'en-US' ? 'Cat Mokugyo - 2,000 total taps' : '猫の木魚 - 累計2,000回' },
      { '@type': 'ListItem', position: 7, name: lang === 'zh-TW' ? '彩虹木魚 - 解鎖5種木魚' : lang === 'en-US' ? 'Rainbow Mokugyo - unlock 5 fish' : '虹の木魚 - 5種解除' },
      { '@type': 'ListItem', position: 8, name: lang === 'zh-TW' ? '宇宙木魚 - 累計10,000次' : lang === 'en-US' ? 'Cosmic Mokugyo - 10,000 total taps' : '宇宙の木魚 - 累計10,000回' },
    ],
  };

  // 1️⃣1️⃣ DefinedTermSet Schema (術語定義)
  const definedTermSchema = {
    '@context': 'https://schema.org',
    '@type': 'DefinedTermSet',
    '@id': `${pageUrl}#glossary`,
    name: lang === 'zh-TW' ? '木魚遊戲術語表' : lang === 'en-US' ? 'Mokugyo Game Glossary' : '木魚ゲーム用語集',
    hasDefinedTerm: [
      {
        '@type': 'DefinedTerm',
        name: lang === 'zh-TW' ? '木魚' : lang === 'en-US' ? 'Mokugyo (Wooden Fish)' : '木魚',
        description:
          lang === 'zh-TW'
            ? '木魚是佛教法器，敲擊時發出空洞的聲音，用於誦經和修行。在本遊戲中，玩家透過敲擊虛擬木魚累積功德。'
            : lang === 'en-US'
            ? 'Mokugyo (wooden fish) is a Buddhist percussion instrument struck during chanting. In this game, players tap virtual mokugyo to accumulate merit.'
            : '木魚は仏教の法器で、お経を唱える際に叩かれます。このゲームでは、プレイヤーが仮想木魚をタップして功徳を積みます。',
        inDefinedTermSet: `${pageUrl}#glossary`,
      },
      {
        '@type': 'DefinedTerm',
        name: lang === 'zh-TW' ? '功德' : lang === 'en-US' ? 'Merit (Gongde)' : '功徳',
        description:
          lang === 'zh-TW'
            ? '功德是佛教概念，指善行帶來的精神果報。在遊戲中，功德類型的敲擊可累積修行能量。'
            : lang === 'en-US'
            ? 'Merit (Gongde) is a Buddhist concept referring to spiritual rewards from good deeds. In the game, Merit-type tapping accumulates spiritual energy.'
            : '功徳は仏教の概念で、善行による精神的な報酬を指します。ゲームでは、功徳タイプのタップで修行エネルギーを蓄積します。',
        inDefinedTermSet: `${pageUrl}#glossary`,
      },
      {
        '@type': 'DefinedTerm',
        name: lang === 'zh-TW' ? '連擊' : lang === 'en-US' ? 'Combo' : 'コンボ',
        description:
          lang === 'zh-TW'
            ? '在2秒內連續敲擊木魚可形成連擊。連擊越高，獎勵越豐富，並有機會解鎖特殊成就。'
            : lang === 'en-US'
            ? 'Tapping the mokugyo within 2 seconds builds a combo. Higher combos earn more rewards and unlock special achievements.'
            : '2秒以内に木魚を連続タップするとコンボが形成されます。コンボが高いほど報酬が豊富で、特別実績を解除できます。',
        inDefinedTermSet: `${pageUrl}#glossary`,
      },
      {
        '@type': 'DefinedTerm',
        name: lang === 'zh-TW' ? '自動敲擊' : lang === 'en-US' ? 'Auto-tap' : 'オートタップ',
        description:
          lang === 'zh-TW'
            ? '自動敲擊功能讓木魚每秒自動敲擊一次，適合放置遊戲和長時間修行。點擊閃電圖標（⚡）開啟。'
            : lang === 'en-US'
            ? 'Auto-tap enables the mokugyo to tap once per second automatically, perfect for idle gameplay. Enable via the lightning ⚡ icon.'
            : 'オートタップ機能は木魚を毎秒1回自動タップします。放置プレイに最適。稲妻⚡アイコンで有効化。',
        inDefinedTermSet: `${pageUrl}#glossary`,
      },
    ],
  };

  // 1️⃣2️⃣ Event Schema (每日登入活動)
  const eventSchema = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    '@id': `${pageUrl}#daily-login-event`,
    name:
      lang === 'zh-TW'
        ? '木魚遊戲每日登入活動'
        : lang === 'en-US'
        ? 'Mokugyo Game Daily Login Event'
        : '木魚ゲーム毎日ログインイベント',
    description:
      lang === 'zh-TW'
        ? '每日登入木魚敲擊遊戲，連續7天獲得不同獎勵。第1天：功德紅包，第7天：星光護符。'
        : lang === 'en-US'
        ? 'Log in to Mokugyo Clicker Game daily to receive different rewards for 7 consecutive days. Day 1: Merit Envelope, Day 7: Starlight Charm.'
        : '木魚叩きゲームに毎日ログインして7日間連続で異なる報酬を獲得。1日目：功徳紅包、7日目：星光護符。',
    startDate: '2025-01-01T00:00:00+08:00',
    endDate: '2030-12-31T23:59:59+08:00',
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    location: { '@type': 'VirtualLocation', url: pageUrl },
    organizer: { '@id': 'https://homy.hk/#organization' },
    isAccessibleForFree: true,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'TWD',
      availability: 'https://schema.org/InStock',
      validFrom: '2025-01-01',
      validThrough: '2030-12-31',
    },
  };

  // 插入所有結構化數據
  const schemas = [
    websiteSchema,
    organizationSchema,
    webPageSchema,
    softwareAppSchema,
    videoGameSchema,
    faqSchema,
    howtoSchema,
    breadcrumbSchema,
    achievementListSchema,
    specialFishListSchema,
    definedTermSchema,
    eventSchema,
  ];

  schemas.forEach((schema) => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-dynamic', 'true');
    script.setAttribute('data-schema-type', schema['@type']);
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  });
};